import { domain } from "../../domain";

export {
    lowStock
}

function lowStock(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/pos/get-lowStock?id=${id}`;
    } else if(name){
        return `${domain}/pos/get-lowStock?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/pos/get-lowStock?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}